import MaterialTable, { MTableCell } from '@material-table/core'
import { Chip, Link, Typography } from '@material-ui/core'
import { makeStyles, MuiThemeProvider } from '@material-ui/core/styles'
import React, { useEffect, useRef, useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'

import { getChipStyles } from '../../services/helpers'
import { table } from '../../services/theme'
import { sortByKey } from '../../utils'
import { ActivitiesToolbar } from './Toolbars/Activities/ActivitiesToolbar'

const useStyles = makeStyles((theme) => ({
	headerButton: {
		fontFamily: 'Nunito',
		fontWeight: '700',
		'& .MuiButton-label': {
			lineHeight: '19px',
			fontSize: '14px'
		}
	},
	addClientButton: {
		color: theme.palette.secondary.main,
		borderColor: theme.palette.secondary.main,
		padding: '7px 40px 8px 24px',
		'& .MuiButton-label': {
			'& .MuiButton-startIcon': {
				marginRight: 16
			}
		}
	},
	toolbarWrapper: {
		display: 'flex',
		flexDirection: 'column',
		backgroundColor: '#F9F9F9'
	},
	petStatusIcon: {
		position: 'absolute',
		left: 0
	},
	toolbarExtras: {
		display: 'flex',
		'& > *': {
			marginRight: '16px'
		}
	},
	toolbar: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		padding: '0px 12px',
		'& > div:nth-child(1)': {
			'& > div:nth-child(4)': {
				flex: 'auto'
			}
		}
	},
	datePickerContainer: {
		display: 'flex',
		alignItems: 'center',
		position: 'relative'
	},
	datePicker: {
		color: '#FFFFFF',
		opacity: 0,
		position: 'absolute',
		top: 0,
		height: 38,
		margin: 0,
		'& *': {
			height: 0,
			padding: 0,
			margin: 0
		}
	},
	calendarButton: {
		'& svg': {
			fill: theme.palette.primary.main
		}
	},
	calendarHeaderButtons: {
		fill: theme.palette.primary.main
	},
	calendarDateButton: {
		zIndex: 1,
		border: '1px solid #D0CFD2',
		padding: '7px 16px 8px 24px',
		color: '#4D4C4F',
		fontWeight: '700',
		'& .MuiButton-label': {
			'& .MuiButton-endIcon': {
				marginLeft: 16
			},
			whiteSpace: 'nowrap'
		}
	},
	dateChangeButton: {
		border: '1px solid #D0CFD2',
		height: 38,
		width: 38,
		padding: 5,
		'& svg': {
			height: 16
		}
	},
	addAppointmentButton: {
		color: theme.palette.secondary.main,
		borderColor: theme.palette.secondary.main,
		padding: '7px 40px 8px 24px',
		'& .MuiButton-label': {
			'& .MuiButton-startIcon': {
				marginRight: 16
			}
		}
	},
	timeTable: {
		width: '24%',
		backgroundColor: '#F3F3F3',
		borderRadius: 6,
		display: 'flex',
		flexDirection: 'column',
		padding: 14,
		justifyContent: 'flex-start',
		'& h4': {
			marginTop: 0,
			marginBottom: 5,
			textTransform: 'capitalize',
			fontFamily: 'Nunito',
			fontWeight: '800',
			fontSize: 16
		}
	},
	timeRow: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		marginBottom: 5,
		padding: 4,
		width: '100%',
		'& span': {
			textTransform: 'capitalize',
			fontFamily: 'Nunito',
			fontWeight: '600',
			fontSize: 14
		},
		'&:nth-child(odd)': {
			backgroundColor: '#F9F9F9',
			borderRadius: 6
		}
	},
	timeRowLight: {},
	chipRow: {
		height: '100%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center'
	},
	spacer: {
		margin: '5px 16px 5px 0px',
		width: '24px',
		position: 'relative',
		'&:before': {
			content: "''",
			position: 'absolute',
			height: '1px',
			width: '100%',
			top: 'calc(50% - 1px)',
			left: 0,
			backgroundColor: '#F3F3F3'
		}
	}
}))

export const ActivitiesTable = (props) => {
	const classes = useStyles()
	const tableRef = useRef(null)
	const toolbarRef = useRef(null)

	let { date, setDate, changeDate, pets, addOnTypes, allAddOns, openAddOnDialog, addons_categories } = props

	const [addOns, setAddOns] = useState(allAddOns)

	useEffect(() => {
		if (allAddOns) {
			setAddOns(allAddOns)
		}
	}, [allAddOns])

	const getTimeTables = () => {
		let times = ['morning', 'midday', 'evening', 'night']

		return times.map((time, i) => {
			return (
				<div className={classes.timeTable} key={`${time}${i}`}>
					<h4 className={classes.timeTitle}>{time}</h4>
					<div>
						<div className={classes.timeRow}>
							<span>Meals</span>
							<span>{getMealText(time)}</span>
						</div>
						<div className={classes.timeRow}>
							<span>Medications</span>
							<span>{getMedText(time)}</span>
						</div>
						{addons_categories.sort(sortByKey((a) => a.order)).map((addons_category, i) => {
							return (
								<div className={classes.timeRow}>
									<span>{addons_category.name}</span>
									<span>{getGenericAddonText(time, addons_category._id)}</span>
								</div>
							)
						})}
						{/*
						<div className={classes.timeRow}>
							<span>Treats</span>
							<span>{getTreatText(time)}</span>
						</div>
						<div className={classes.timeRow}>
							<span>Grooming</span>
							<span>{getGroomText(time)}</span>
						</div>

						<div className={classes.timeRow}>
							<span>Other</span>
							<span>{getOtherText(time)}</span>
						</div> */}
					</div>
				</div>
			)
		})
	}

	const getGenericAddonText = (time, type_id) => {
		let totalAddonArray = addOns.filter((a) => a.time === time && a.date === date && a.type === type_id)

		let inProgArray = totalAddonArray.filter((a) => a.completed)

		return `${inProgArray.length} / ${totalAddonArray.length}`
	}

	const getMealText = (time) => {
		let totalMealsArray = addOns.filter((a) => a.time === time && a.date === date && a.category === 'meal')

		let inProgArray = totalMealsArray.filter((meal) => meal.status === 'prepared' || meal.completed)

		return `${inProgArray.length} / ${totalMealsArray.length}`
	}

	const getMedText = (time) => {
		// this is only meds that are in progress or completed.
		// these will exist only in the medications array - but still need to filter out the 'waiting' ones,
		// since meds can be added one-off (unlike meals)
		let inProgArray = []

		// these are all the meds, so it will be ones from the meds array,
		// plus any from the pet profile that aren't already in the med array
		let totalArray = []

		let meds = addOns.filter((a) => a.pet_id && a.med_id)

		meds.forEach((med) => {
			if (med.time === time && med.date === date) {
				if (med.status === 'prepared' || med.status === 'delivered') {
					inProgArray.push(med)
				}

				totalArray.push(med)
			}
		})

		return `${inProgArray.length} / ${totalArray.length}`
	}

	const renderPet = (addOn) => {
		if (!addOn.pet_id) return null
		let pet = pets.find((p) => p._id === addOn.pet_id)
		let primary = pet?.household?.accounts?.find((a) => a.primary)

		if (pet) {
			return (
				<div>
					<Link
						component={RouterLink}
						style={{
							textTransform: 'capitalize',
							color: '#6B4AD6',
							fontWeight: 600,
							fontSize: '16px',
							lineHeight: '22px'
						}}
						onClick={(e) => e.stopPropagation()}
						to={`/clients/${pet.household_id}/pets/${pet._id}`}>
						{`${pet.name}${primary && primary.last_name ? ` ${primary.last_name}` : ''}`}
					</Link>
				</div>
			)
		}
		return null
	}

	const renderStatus = (addOn) => {
		let status
		if (!addOn.status || addOn.status === 'waiting') {
			status = 'Waiting'
		} else {
			status = addOn.status
		}

		return (
			<div className={classes.chipRow}>
				<Chip label={status ? status : 'No Status'} style={status ? getChipStyles(status) : null} />
			</div>
		)
	}

	const renderName = (data) => {
		let name = data.name
		if (data.addon_choice_id) {
			const ourType = addOnTypes.find((type) => type._id == data.addon_id)
			if (ourType?.addon_choices?.length) {
				const choice = ourType.addon_choices.find((c) => c.id === data.addon_choice_id)
				if (choice) name += ` - ${choice.name}`
			}
		}

		return (
			<div>
				<Typography
					style={{
						textTransform: 'capitalize',
						color: '#6B4AD6',
						fontWeight: 800,
						fontSize: '16px',
						lineHeight: '22px'
					}}>
					{name}
				</Typography>
			</div>
		)
	}

	const renderTime = (data) => {
		return (
			<div>
				<Typography
					style={{
						textTransform: 'capitalize',
						color: '#1A1A35',
						fontWeight: 600,
						fontSize: '14px',
						lineHeight: '22px'
					}}>
					{data.time}
				</Typography>
			</div>
		)
	}

	return (
		<MuiThemeProvider theme={table}>
			<ActivitiesToolbar
				ref={toolbarRef}
				tableRef={tableRef}
				date={date}
				getTimeTables={getTimeTables}
				setDate={setDate}
				changeDate={changeDate}
				addOns={addOns}
			/>
			<MaterialTable
				tableRef={tableRef}
				date={props.date}
				options={{
					headerStyle: {
						color: '#1A1A35',
						textTransform: 'uppercase',
						fontWeight: 800,
						fontSize: '12px',
						lineHeight: '16px',
						padding: '11px 24px',
						borderTop: '1px solid #D0CFD2',
						backgroundColor: '#F9F9F9'
					},
					rowStyle: {
						verticalAlign: 'top',
						fontSize: 16
					},
					pageSize: 10,
					pageSizeOptions: [10, 20, 50],
					toolbarButtonAlignment: 'left',
					searchFieldAlignment: 'left',
					toolbar: false
				}}
				columns={[
					{
						title: 'Time Block',
						render: (data) => renderTime(data),
						customSort: (a, b) => (a && a.time && b && b.time ? a.time.localeCompare(b.time) : null),
						customFilterAndSearch: (term, rowData) =>
							rowData.time ? rowData.time.toUpperCase().includes(term.toUpperCase()) : false
					},
					{
						title: 'Activities',
						render: (data) => renderName(data),
						customSort: (a, b) => {
							let aName = a ? a.name : a.category
							let bName = b ? b.name : b.category
							return aName.localeCompare(bName)
						},
						customFilterAndSearch: (term, rowData) =>
							rowData.name ? rowData.name.toUpperCase().includes(term.toUpperCase()) : false
					},
					{
						title: 'Pet',
						render: (data) => renderPet(data),
						customSort: (a, b) => {
							let aPet = pets.find((p) => p._id === a.pet_id)
							let bPet = pets.find((p) => p._id === b.pet_id)

							let aPetName = aPet ? aPet.name : 'No Name'
							let bPetName = bPet ? bPet.name : 'No Name'
							return aPetName.localeCompare(bPetName)
						},
						customFilterAndSearch: (term, rowData) => {
							if (rowData.pet_id) {
								let pet = pets.find((p) => p._id === rowData.pet_id)

								return pet && pet.name
									? pet.name.toUpperCase().includes(term.toUpperCase())
									: false
							} else {
								return false
							}
						}
					},
					{
						title: 'Status',
						render: (data) => renderStatus(data),
						customSort: (a, b) => {
							let aStatus = a && a.status ? a.status : 'waiting'
							let bStatus = b && b.status ? b.status : 'waiting'
							return aStatus.localeCompare(bStatus)
						},
						customFilterAndSearch: (term, rowData) => {
							let status =
								!rowData.status || rowData.status === 'waiting' ? 'waiting' : rowData.status

							return status.toUpperCase().includes(term.toUpperCase())
						}
					}
				]}
				data={addOns}
				onRowClick={(e, addOn) => {
					let pet = pets.find((p) => p._id === addOn.pet_id)
					openAddOnDialog(addOn, pet)
				}}
				components={{
					Cell: (props) => (
						<MTableCell
							style={{
								borderBottom: 'none',
								padding: '16px 36px 16px 24px'
							}}
							{...props}
						/>
					)
				}}
				title="Activities"
			/>
		</MuiThemeProvider>
	)
}
